export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const UNSET_CURRENT_USER = "UNSET_CURRENT_USER";
export const SET_CURRENT_USER_STATUS = 'SET_CURRENT_USER_STATUS';
export const SHOW_ACCOUNT_SETTINGS = 'SHOW_ACCOUNT_SETTINGS';
export const SET_CURRENT_USER_PREFERENCE = 'SET_CURRENT_USER_PREFERENCE';